export enum PageAction {
  DISCARD = 'discard',
  SAVE_DRAFT = 'saveDraft',
  CANCEL = 'cancel',
  RETURN_TO_LIST = 'returnToList',
}
